<template>
  <details class="inspection-evidence card" open>
    <summary>检验备注与现场附件（选填）</summary>
    <ATextarea v-model="inspection.remark" :disabled="disabled" :auto-size="{ minRows: 3 }" placeholder="异常情况或补充说明" />
    <label class="upload" :class="{ disabled }">
      <span>上传现场图片</span>
      <input type="file" multiple accept="image/*" :disabled="disabled" @change="changeEvidence" />
    </label>
    <div v-if="inspection.evidence.length" class="evidence-list">
      <div v-for="(evidence, evidenceIndex) in inspection.evidence" :key="evidence.key" class="evidence-item"
        :class="{ previewable: evidence.preview || evidence.url }" @click="previewEvidence(evidence)">
        <img v-if="evidence.preview || evidence.url" :src="evidence.preview || evidence.url" :alt="evidence.name" />
        <span v-else class="evidence-placeholder">图片</span>
        <span class="evidence-name" :title="evidence.name">{{ evidence.name }}</span>
        <button v-if="!disabled" type="button" class="remove-evidence" @click.stop="removeEvidence(evidenceIndex)">×</button>
      </div>
    </div>
    <XModal ref="evidencePreviewModal" title="图片预览" :width="900" :ok-btn="false">
      <div v-if="previewEvidenceItem" class="evidence-preview">
        <img :src="previewEvidenceItem.preview || previewEvidenceItem.url" :alt="previewEvidenceItem.name" />
        <p>{{ previewEvidenceItem.name }}</p>
      </div>
    </XModal>
  </details>
</template>

<script>
export default {
  name: "InspectionRemarkAttachment",
  props: {
    inspection: { type: Object, required: true },
    photoList: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { previewEvidenceItem: null };
  },
  watch: {
    photoList: {
      immediate: true,
      handler(photoList) {
        this.releaseEvidence(this.inspection.evidence);
        this.inspection.evidence = this.normalizeEvidence(photoList);
      },
    },
  },
  methods: {
    normalizeEvidence(photoList) {
      return (Array.isArray(photoList) ? photoList : []).map((file, index) => ({
        id: file.id || file.fileId || file.attachmentId || "",
        name: file.name || file.fileName || file.originalFileName || `现场附件 ${index + 1}`,
        url: this.normalizeFileUrl(file.url || file.fileUrl || file.path || file.filePath || ""),
        preview: "",
        file: null,
        key: `old-${file.id || file.fileId || file.attachmentId || index}`,
      }));
    },
    normalizeFileUrl(url) {
      if (!url || /^(https?:|data:|blob:)/i.test(url)) return url;
      const serverUrl = this.$publicJs.getServerUrl().replace(/\/$/, "");
      return `${serverUrl}/${url.replace(/^\//, "")}`;
    },
    changeEvidence(event) {
      const files = Array.from(event.target.files || []);
      const imageFiles = files.filter((file) => file.type && file.type.indexOf("image/") === 0);
      if (imageFiles.length !== files.length) this.$message.warning("只能上传图片文件。");
      const newEvidence = imageFiles
        .filter((file) => !this.inspection.evidence.some((item) => item.file && item.file.name === file.name && item.file.size === file.size && item.file.lastModified === file.lastModified))
        .map((file) => ({
          id: "",
          name: file.name,
          url: "",
          preview: URL.createObjectURL(file),
          file,
          key: `new-${file.name}-${file.size}-${file.lastModified}`,
        }));
      this.inspection.evidence = this.inspection.evidence.concat(newEvidence);
      event.target.value = "";
    },
    removeEvidence(index) {
      const [evidence] = this.inspection.evidence.splice(index, 1);
      this.releaseEvidence([evidence]);
    },
    previewEvidence(evidence) {
      if (!evidence.preview && !evidence.url) return;
      this.previewEvidenceItem = evidence;
      this.$nextTick(() => this.$refs.evidencePreviewModal.open());
    },
    releaseEvidence(evidenceList) {
      (evidenceList || []).forEach((evidence) => {
        if (evidence && evidence.preview) URL.revokeObjectURL(evidence.preview);
      });
    },
  },
  beforeDestroy() {
    this.releaseEvidence(this.inspection.evidence);
  },
};
</script>

<style lang="less" scoped>
.card { padding: 18px; margin-bottom: 16px; background: #fff; border: 1px solid #dce4ec; border-radius: 14px; }
summary { cursor: pointer; font-weight: 600; }
.upload { display: inline-flex; align-items: center; min-height: 42px; padding: 8px 12px; margin-top: 10px; color: #245d91; border: 1px solid #9fb9d2; border-radius: 8px; cursor: pointer; }
.upload.disabled { color: #9aa9b8; cursor: not-allowed; opacity: 0.7; }
.upload input { max-width: 250px; margin-left: 8px; }
.evidence-list { display: grid; grid-template-columns: repeat(auto-fill, minmax(116px, 1fr)); gap: 10px; margin-top: 12px; }
.evidence-item { position: relative; display: flex; flex-direction: column; min-width: 0; padding: 6px; background: #f6f9fc; border: 1px solid #d9e5f0; border-radius: 8px; }
.evidence-item.previewable { cursor: zoom-in; }
.evidence-item img, .evidence-placeholder { display: block; width: 100%; height: 88px; object-fit: cover; color: #71859a; line-height: 88px; text-align: center; background: #e8f0f7; border-radius: 5px; }
.evidence-name { overflow: hidden; margin-top: 6px; font-size: 12px; line-height: 18px; text-overflow: ellipsis; white-space: nowrap; }
.remove-evidence { position: absolute; top: 2px; right: 2px; width: 20px; height: 20px; padding: 0; color: #fff; font-size: 18px; line-height: 18px; background: rgba(25, 45, 69, 0.7); border: 0; border-radius: 50%; cursor: pointer; }
.evidence-preview { text-align: center; }
.evidence-preview img { display: block; max-width: 100%; max-height: 70vh; margin: 0 auto; object-fit: contain; }
.evidence-preview p { margin: 12px 0 0; color: #62758a; }
</style>
